import React, { useEffect } from "react";
//import Scss
import "./assets/scss/themes.scss";
//imoprt Route
import Route from "./Routes";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

function App() {
	return (
		<React.Fragment>
			<Route />
		</React.Fragment>
	);
}

export default App;